import { PageBody, PageHeader } from '@/components/layout/page-header';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Tela protegida enquanto as roles não chegam: o cabeçalho real da tela (que
 * não depende de permissão) e um skeleton no lugar do conteúdo — nunca o
 * "sem acesso", que só vale depois de saber quem a pessoa é.
 */
export function TelaProtegidaCarregando({
  titulo,
  descricao,
  eyebrow,
}: {
  titulo: string;
  descricao: string;
  eyebrow?: string;
}) {
  return (
    <PageBody>
      <PageHeader eyebrow={eyebrow} titulo={titulo} descricao={descricao} />
      <div className="flex flex-col gap-3" role="status" aria-label="Verificando suas permissões">
        <Skeleton className="h-12 rounded-card" />
        <Skeleton className="h-64 rounded-card" />
      </div>
    </PageBody>
  );
}
